// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__9LO8k","page__scroll":"Page_page__scroll__ULhma"};